module.exports = __webpack_public_path__ + "sootang-pc/img/logo8652852.99c2524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo8652852.png
// module id = gD4L
// module chunks = 11